import type { SVGProps } from 'react';

const SvgAccessControl = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M17 20H7a1 1 0 0 1-.93-1.37l2.19-5.51c.13-.33.08-.71-.15-.98a4.96 4.96 0 0 1-1.05-3.98c.37-2.17 2.14-3.87 4.33-4.12 1.43-.17 2.86.28 3.93 1.23a5 5 0 0 1 .55 6.9c-.21.26-.26.63-.13.96l2.19 5.51c.12.31.08.66-.1.93s-.5.44-.83.44zm-8.53-2h7.05l-1.65-4.14a2.97 2.97 0 0 1 .44-2.97c.44-.54.68-1.19.68-1.89 0-.86-.37-1.67-1.01-2.24-.65-.58-1.49-.84-2.36-.73-1.29.15-2.38 1.19-2.59 2.47-.14.87.08 1.72.63 2.39.68.83.85 1.98.45 2.98l-1.65 4.14z"
    />
  </svg>
);
export default SvgAccessControl;
